export const generateRetargetingCookieName = (ret: string) => {
  return `ota-ret-${ret}`
}
